import { CircularProgress, Stack } from "@mui/material";
import React from "react";

export const CenteredSpinner: React.FC = () => (
    <Stack alignItems="center" justifyContent="center" sx={{ height: "100%" }}>
        <CircularProgress />
    </Stack>
);
